import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { useMedia } from "@hooks/useMedia";
import { useStores } from "@stores";
import { DIALOG_TYPE } from "@stores/DialogStore";

import { SideBar } from "./SideBar";
import { SideBarMain } from "./SideBarMain";

export const SideBarAssets = observer(() => {
  const { dialogStore } = useStores();
  const { desktop } = useMedia();

  const handleClose = () => {
    dialogStore.close(DIALOG_TYPE.ASSETS);
  };

  const isSideBarOpen = dialogStore.isVisible(DIALOG_TYPE.ASSETS);
  const handleDeposit = () => {
    dialogStore.open(DIALOG_TYPE.DEPOSIT);
  };

  useEffect(() => {
    if (isSideBarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isSideBarOpen]);

  return (
    <>
      <AnimatePresence>
        {isSideBarOpen && desktop && (
          <StyledBackdrop
            data-testid="assets:sidebar-backdrop"
            initial={{ opacity: 0.5 }}
            transition={{ duration: 0.3 }}
            onClick={handleClose}
          />
        )}
      </AnimatePresence>

      <StyledSideBarWrapper data-testid="assets:sidebar" desktop={desktop} isSideBarOpen={isSideBarOpen}>
        <SideBar isVisible={isSideBarOpen} style={{ height: "100%" }} onClose={handleClose}>
          <AnimatePresence>
            <StyledSideBarContent
              data-testid="assets:sidebar-content"
              animate={{ x: 0 }}
              exit={{ x: -300 }}
              initial={{ x: 300 }}
              transition={{ duration: 0.5 }}
            >
              <SideBarMain handleDeposit={handleDeposit} />
            </StyledSideBarContent>
          </AnimatePresence>
        </SideBar>
      </StyledSideBarWrapper>
    </>
  );
});

const StyledBackdrop = styled(motion.div)`
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  z-index: 97;
`;

const StyledSideBarContent = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const StyledSideBarWrapper = styled.div<{ desktop: boolean; isSideBarOpen: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  z-index: ${({ desktop, isSideBarOpen }) => (desktop || isSideBarOpen ? 1000 : 100)};
`;
